import { getTooltipTitle } from '@aibees/elephant/components/company-info-badge/config';
import { useCompanyVisibilityState } from '@aibees/elephant/hooks';
import { useMemo } from 'react';

export function useCompanyTooltipTitle(shouldShow: boolean) {
  const {
    isSelfEmployedOrFreelancer,
    employmentType,
    hasOnlyCompanyName,
    isNoLongerEmployed,
    noPreviousCompanyDataAvailable,
    hasOnlyPreviousCompanyName,
    wasPreviouslySelfEmployedOrFreelancer,
    previousEmploymentType,
  } = useCompanyVisibilityState();

  return useMemo(() => {
    if (!shouldShow) {
      return null;
    }

    return getTooltipTitle({
      isSelfEmployedOrFreelancer,
      employmentType,
      hasOnlyCompanyName,
      isNoLongerEmployed,
      noPreviousCompanyDataAvailable,
      hasOnlyPreviousCompanyName,
      wasPreviouslySelfEmployedOrFreelancer,
      previousEmploymentType,
    });
  }, [
    shouldShow,
    isSelfEmployedOrFreelancer,
    employmentType,
    hasOnlyCompanyName,
    isNoLongerEmployed,
    noPreviousCompanyDataAvailable,
    hasOnlyPreviousCompanyName,
    wasPreviouslySelfEmployedOrFreelancer,
    previousEmploymentType,
  ]);
}
